import { useRef, useCallback } from 'react';

const useLongPress = (onLongPress, duration = 500) => {
  const timerRef = useRef(null);
  const didLongPress = useRef(false);
  const isActivated = useRef(false); // ← tracks if drag is unlocked

  const start = useCallback(
    payload => {
      didLongPress.current = false;
      isActivated.current = false;
      timerRef.current = setTimeout(() => {
        didLongPress.current = true;
        isActivated.current = true; // ← unlock drag
        onLongPress(payload);
      }, duration);
    },
    [onLongPress, duration],
  );

  const cancel = useCallback(() => {
    clearTimeout(timerRef.current);
    isActivated.current = false;
  }, []);

  const wasLongPress = useCallback(() => didLongPress.current, []);

  // Call this in onDragStart — returns true if drag should be blocked
  const shouldBlockDrag = useCallback(() => !isActivated.current, []);

  return { start, cancel, wasLongPress, shouldBlockDrag };
};

export default useLongPress;
